module.exports = __webpack_public_path__ + "static/media/8819.806a94dc.png";